<template>
  <div class="companiesIntro">
    <headerBar title="农产品溯源中心"></headerBar>
    <companyBar :store_name="store_name" :logo="store_logo"></companyBar>
    <div class="tabbar h-f-c-sb" v-if="is_new == 0">
      <div class="item" :class="status_type == 1 ? 'active' : ''" @click="(status_type = 1), checkInfo()">使用中</div>
      <div class="item" :class="status_type == 0 ? 'active' : ''" @click="(status_type = 0), checkInfo()">审核中</div>
      <div class="item" :class="status_type == -1 ? 'active' : ''" @click="(status_type = -1), checkInfo()">审核结果</div>
    </div>

    <div v-show="status_type == 1">
      <div class="box710" v-if="is_new == 0">
        <div class="title">企业简介</div>
        <div class="content">{{ introduce ? introduce : '企业简介正在审核...' }}</div>
        <div @click="is_new = 1" v-if="introduce" style="display: flex;justify-content: flex-end;"><div class="opt-btn">修改</div></div>
      </div>

      <div class="box710" v-if="is_new == 1">
        <div class="title">企业简介</div>
        <textarea maxlength="-1" name="" id="" cols="30" rows="10" v-model="introduce"></textarea>
        <div @click="submitTxt" style="display: flex;justify-content: flex-end;"><div class="opt-btn">完善/修改</div></div>
      </div>

      <div class="box710">
        <div class="title">企业相册</div>
        <div style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;">
          <div class="up-load" @click="upLoadImgBtn(index)" v-for="(item, index) in album" :key="index">
            <div class="default" v-if="!item"><img class="default-img" src="../../static/images/canmera.png" alt="" /></div>
            <div v-if="item" style="position: relative;">
              <img class="upload-show" :src="'https://yuan.znstny.cn/' + item.photo" alt="" />
              <img class="close" @click="deletePhoto(item.id)" src="../../static/images/close_02.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="status_type == 0">
      <div class="box710">
        <div class="title">企业简介</div>
        <div class="content">{{ introduce }}</div>
      </div>
    </div>

    <div v-show="status_type == -1">
      <div class="box710" v-if="introduce">
        <div class="title">企业简介</div>
        <textarea maxlength="-1" name="" id="" cols="30" rows="10" v-model="introduce"></textarea>
        <p style="color: red;">审核失败,原因：{{ refuse_msg }}</p>
        <div @click="submitTxt" style="display: flex;justify-content: flex-end;"><div class="opt-btn">修改</div></div>
      </div>
    </div>

    <input type="file" id="imgupload" @change="uploadImg(location, $event)" style="display:none" />
  </div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui';
export default {
  data() {
    return {
      location: 0, //图片下标索引
      is_new: 0,
      store_name: '',
      store_logo: '',
      status_type: 1,
      introduce: '',
      album: [],
      textid: 0,
      potoid: 0,
      refuse_msg: ''
    };
  },
  created() {

  },
  mounted() {
  	//判断登陆状态,
  	if (!window.localStorage.getItem('is_check_login') || window.localStorage.getItem('is_check_login') == 0) {
  	  //登陆失败
  	  this.$router.push('/login');
  	} else {
  	  this.checkInfo();
  	  this.checkShopInfo();
  	  this.getPotoList();
  	}
  },
  destroyed() {
    MessageBox.close();
  },
  methods: {
    //查看相册
    getPotoList() {
      this.$request.post('/front/Appsto/stoalbum', {}, res => {
        console.log(res);
        if (res.status == 1) {
          this.album = res.result || ['', '', '', '', ''];
        }
      });
    },
    deletePhoto(id) {
      this.$request.post('/front/Appsto/delstoalb', { id }, res => {
        console.log(res);
        if (res.status == 1) {
          this.getPotoList();
        }
        Toast(res.msg);
      });
    },
    potoPost(location, photo) {
      let data = new FormData();
      data.append('location', location);
      data.append('photo', photo);
      this.$request.post('/front/Appsto/changestoalb', data, res => {
        console.log(res);
        this.getPotoList();
        Toast(res.msg);
      });
    },
    uploadImg(location, e) {
      let file = e.target.files[0];
      let type = file.type.split('/')[0];
      if (type == 'image') {
        //图片转成base64
        let reader = new FileReader();
        reader.readAsDataURL(file);
        //上传
        reader.onloadend = () => {
          let dataUrl = reader.result;
          this.potoPost(location + 1, file);
          e.target.value = '';
        };
      } else {
        Toast('请上传图片');
      }
    },
    upLoadImgBtn(index) {
      this.location = index;
      document.getElementById('imgupload').click();
    },
    submitTxt() {
      if (!this.introduce) {
        Toast('请填写企业简介');
        return false;
      }
      if (this.introduce.length > 1000) {
        Toast('企业简介不能超过1000字');
        return false;
      }

      let data = {
        intro: this.introduce,
        id: this.textid
      };

      this.$request.post('/front/Appsto/changestoinfo', data, res => {
        Toast(res.msg);
        if (res.status == 1) {
          //提交成功返回审核中页面，清空数据
          this.status_type = 0;
          this.is_new = 0;
        }
      });
    },
    checkShopInfo() {
      //检查商家信息
      this.$request.post(
        '/front/Store/info',
        {
          // id: window.localStorage.getItem('store_id'),
          // token: window.localStorage.getItem('token')
        },
        res => {
          console.log(res);
          if (res.status == 1) {
            this.store_name = res.result.store_name;
            this.store_logo = res.result.logo;
          }
        }
      );
    },
    checkInfo() {
      let data = {
        // id: window.localStorage.getItem('store_id'),
        // token: window.localStorage.getItem('token'),
        type: this.status_type
      };
      this.$request.post('/front/Appsto/stoinfo', data, res => {
        console.log(res);
        if (res.status == 1) {
          if (this.status_type == 1) {
            //使用中，审核成功
            this.is_new = res.result.is_new;
            if (this.is_new == 1) {
              MessageBox.alert('您尚未完善信息，请及时完善', '提示');
            }
          } else if (this.status_type == 0) {
            //审核中
          } else if (this.status_type == -1) {
            //审核失败
            this.refuse_msg = res.result.introduce.refuse_msg;
          }
          console.log(this.album);
          this.introduce = res.result.introduce.introduce || '';
          this.textid = res.result.introduce.id;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.companiesIntro {
  padding-top: 0.8rem;
  .tabbar {
    width: 100%;
    height: 0.9rem;
    background: white;
    padding: 0 0.2rem;
    box-sizing: border-box;
    .item {
      flex: 1;
      height: 0.9rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 2px solid transparent;
    }
    .active {
      color: #299e72;
      border-color: #299e72;
    }
  }
  textarea {
    display: block;
    width: 100%;
    background: gainsboro;
    margin: 0.2rem 0;
    border-radius: 5px;
    padding: 0.2rem;
    box-sizing: border-box;
    font-size: 0.3rem;
  }
  .box710 {
    background: white;
    .title {
      font-weight: bold;
      font-size: 0.26rem;
      color: #000000;
    }
    .content {
      padding: 0.2rem;
      font-size: 0.28rem;
    }
    .opt-btn {
      width: 2rem;
      color: #299e72;
      border: 1px solid #299e72;
      border-radius: 0.3rem;
      height: 0.6rem;
      text-align: center;
      line-height: 0.6rem;
      font-size: 0.3rem;
    }
    .up-load {
      align-items: flex-end;
      justify-content: space-between;
      margin-top: 0.3rem;
      position: relative;
      .default {
        width: 1.2rem;
        height: 1.2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #cccccc;
        border-radius: 5px;
        position: relative;
        .default-img {
          width: 0.6rem;
          margin: 0 auto;
        }
      }
    }
  }
  .upload-show {
    display: block;
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 5px;
  }
  .close {
    width: 0.8rem;
    height: 0.8rem;
    padding: 0.2rem;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/companiesIntro.vue